import { cn } from "../utils";

export const HeadingHr = ({ title, className }: { title: string, className?: string }) => {
  return (
    <div className={cn("heading-hr mb-10 text-center", className)}>
      <h1 className="text-lg sm:text-xl md:text-2xl text-center uppercase font-heading font-medium">
        {title}
      </h1>
      <div className="hr" />
    </div>
  );
};
